//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalCoBLandPurchasesWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total CoB Land Purchases' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalCoBLandPurchasesWidget;
